/**
 * 用户相关
 */
import { getAuthResourceTree } from '@/api/index';
const state = {
  visitedViews: [],
  cachedViews: ['_Cooperation'],
  sideBarNav: [],
  sideNavCatch: {} // 缓存导航
};

const actions = {
  /***
   * 获取路由列表
   */
  updateSideBarNav({ commit, rootState }, appCode) {
    if (!appCode) {
      return;
    }
    // 如果已有缓存数据则取缓存数据
    if (Reflect.has(state.sideNavCatch, appCode)) {
      commit('UPDATE_SIDE_BAR_NAV', state.sideNavCatch[appCode]);

      return;
    }
    // 通过接口请求导航列表
    getAuthResourceTree(appCode).then(res => {
      if (res.body && res.body.length && res.body[0].children) {
        commit('UPDATE_SIDE_BAR_NAV', res.body[0].children);
        commit('CATCH_SIDE_BAR_NAV', {
          key: appCode,
          value: res.body[0].children
        });
      } else {
        commit('UPDATE_SIDE_BAR_NAV', []);
        commit('CATCH_SIDE_BAR_NAV', { key: appCode, value: [] });
      }
    });
  },
  addView({ dispatch }, view) {
    dispatch('addVisitedView', view);
    dispatch('addCachedView', view);
  },
  addVisitedView({ commit }, view) {
    commit('ADD_VISITED_VIEW', view);
  },
  addCachedView({ commit }, view) {
    commit('ADD_CACHED_VIEW', view);
  },
  delView({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delVisitedView', view);
      dispatch('delCachedView', view);
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      });
    });
  },
  delVisitedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_VISITED_VIEW', view);
      resolve([...state.visitedViews]);
    });
  },
  delCachedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_CACHED_VIEW', view);
      resolve([...state.cachedViews]);
    });
  },

  delOthersViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delOthersVisitedViews', view);
      dispatch('delOthersCachedViews', view);
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      });
    });
  },
  delOthersVisitedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_VISITED_VIEWS', view);
      resolve([...state.visitedViews]);
    });
  },
  delOthersCachedViews({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_OTHERS_CACHED_VIEWS', view);
      resolve([...state.cachedViews]);
    });
  },

  delAllViews({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delAllVisitedViews', view);
      dispatch('delAllCachedViews', view);
      resolve({
        visitedViews: [...state.visitedViews],
        cachedViews: [...state.cachedViews]
      });
    });
  },
  delAllVisitedViews({ commit, state }) {
    return new Promise(resolve => {
      commit('DEL_ALL_VISITED_VIEWS');
      resolve([...state.visitedViews]);
    });
  },
  delAllCachedViews({ commit, state }) {
    return new Promise(resolve => {
      commit('DEL_ALL_CACHED_VIEWS');
      resolve([...state.cachedViews]);
    });
  },

  updateVisitedView({ commit }, view) {
    commit('UPDATE_VISITED_VIEW', view);
  }
};

const mutations = {
  /**
   * 清理缓存导航
   */
  CLEAR_NAV_CHACHE(state) {
    state.sideNavCatch = {};
  },
  /**
   * 跟新侧边栏导航列表
   * @param state
   * @param data
   * @constructor
   */
  UPDATE_SIDE_BAR_NAV(state, data) {
    state.sideBarNav = [...data];
  },
  /**
   * 缓存侧边栏导航列表
   * @param state
   * @param data
   * @constructor
   */
  CATCH_SIDE_BAR_NAV(state, data) {
    state.sideNavCatch[data.key] = [...data.value];
  },
  // UPDATE_SIDE_BAR_NAV(state, data) {
  //   state.routers = [...data];
  // },
  ADD_VISITED_VIEW: (state, view) => {
    if(view.meta.noVisited) return; // noVisited 用来判断加不加入到tag中
    if (state.visitedViews.some(v => v.path === view.path)) return;
    if (view.name === 'Home') {
      state.visitedViews.unshift(
        Object.assign({}, view, {
          title: view.meta.title || 'no-name'
        })
      );
    } else {
      state.visitedViews.push(
        Object.assign({}, view, {
          title: view.meta.title || 'no-name'
        })
      );
    }
  },
  ADD_CACHED_VIEW: (state, view) => {
    const {matched = []} = view;
    const cur = matched[matched.length - 1];
    const { components } = cur;
    const name = components.default.name;
    if (state.cachedViews.includes(name)) return;
    if (!view.meta.noCache && view.meta.keepAlive) {
      state.cachedViews.push(name);
    }
  },

  DEL_VISITED_VIEW: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1);
        break;
      }
    }
  },
  DEL_CACHED_VIEW: (state, view) => {
    const {matched = []} = view;
    const cur = matched[matched.length - 1];
    const { components } = cur;
    const name = components.default.name;
    for (const i of state.cachedViews) {
      if (i === name) {
        const index = state.cachedViews.indexOf(i);
        state.cachedViews.splice(index, 1);
        break;
      }
    }
  },
  DEL_OTHERS_VISITED_VIEWS: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews = state.visitedViews.slice(i, i + 1);
        break;
      }
    }
  },
  DEL_OTHERS_CACHED_VIEWS: (state, view) => {
    const {matched = []} = view;
    const cur = matched[matched.length - 1];
    const { components } = cur;
    const name = components.default.name;
    for (const i of state.cachedViews) {
      if (i === name) {
        const index = state.cachedViews.indexOf(i);
        state.cachedViews = state.cachedViews.slice(index, index + 1);
        break;
      }
    }
  },

  DEL_ALL_VISITED_VIEWS: state => {
    state.visitedViews = [];
  },
  DEL_ALL_CACHED_VIEWS: state => {
    state.cachedViews = [];
  },

  UPDATE_VISITED_VIEW: (state, view) => {
    for (let v of state.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view);
        break;
      }
    }
  },
  /**
   * 左侧导航
   * */
  UPDATE_ROUTER_LIST(state, data) {
    state.sideBarNav = _.cloneDeep(data);
  }
};

const getters = {};

export default {
  state,
  actions,
  getters,
  mutations
};
